<template>
  <div class="pages page-warranty" v-cloak>
      <headerView  :show-bg="true"></headerView>
    <!-- <img class="bgImg" src="@/assets/images/warranty_bg.png" alt=""> -->
    <div class="center pagecontent" :style="{backgroundImage:'url('+bgImg+')'}">
     <h1 class="title">{{$t('warranty_title')}}</h1>
            <div class="serach-input">
              <el-input @keyup.enter.native="handleFilter" :placeholder="$t('warranty_input')" v-model="installVal">
                  <el-select v-model="searchSelect" slot="prepend" :placeholder="el_select_lang.input_select"  class="search-select">
                    <el-option :label="el_select_lang.phone" value="1">{{el_select_lang.phone}}</el-option>
                    <el-option :label="el_select_lang.barcode" value="2">{{el_select_lang.barcode}}</el-option>
                  </el-select>
                <el-button class="search-btn" slot="append" @click="handleFilter" v-loading="stateSche==1">{{$t('btn_search')}}</el-button>
            </el-input>
          </div>
      
    </div>

    <div class="dialog-mask" v-if="showLicensePlate"></div>
    <div class="column items-center licensePlate-dialog" v-if="showLicensePlate">
       <div class="carNoBox-mask" v-if="licensePlateDoor" @click="licensePlateDoor = false"></div>
        <h2 class="pop-title">{{$t('warranty_input2')}}</h2>
        <div class="relative">
          <div class="carNoBoxInput">
            <div class="view">
              <input class="inputBox" :value="licensePlateUnit[0]" @click="licensePlateDoor = true"/>
              <input class="inputBox" :value="licensePlateUnit[1]" @click="licensePlateDoor = true"/>
              <span class="dot"></span>
              <input class="inputBox" :value="licensePlateUnit[2]" @click="licensePlateDoor = true"/>
              <input class="inputBox" :value="licensePlateUnit[3]" @click="licensePlateDoor = true"/>
              <input class="inputBox" :value="licensePlateUnit[4]" @click="licensePlateDoor = true"/>
              <input class="inputBox" :value="licensePlateUnit[5]" @click="licensePlateDoor = true"/>
              <input class="inputBox" :value="licensePlateUnit[6]" @click="licensePlateDoor = true"/>
              <input v-if="7 === licensePlateUnit.length - 1" class="inputBox" :class="7 === licensePlateUnit.length - 1 ? 'inputBoxActive' : 'inputBox'" :value="licensePlateUnit[7]" @click="licensePlateDoor = true"/>
              <img v-if="7 !== licensePlateUnit.length - 1" src="@/assets/images/newEnergy.png" class="newEnergyIcon" alt="新能源"/>
            </div>
          </div>
         
          <div v-if="licensePlateDoor" class="carNoBoxSeat">
            <div v-if="licensePlateUnit.length < 1" class="carNoBox">
              <span class="carNo" v-for="item in columns" :key="item" @click="pickOn(item)">
                {{item}}
              </span>
              <span class="delBt" @click="delCarNo">X</span>
            </div>
            <div v-if="licensePlateUnit.length >= 1" class="carNoBox">
            <span class="carNo" v-for="item in numberColumns" :key="item" @click="pickOn(item)">
              {{item}}
            </span>
              <div style="display: flex;align-items: center">
                <span class="delBt" @click="delCarNo">X</span>
                <span class="delBt" style="margin-left: 6px;" @click="confirm">确认</span>
              </div>
            </div>
          </div>
          
        </div>
        <el-button type="primary" round class="el-btn" @click="handleLicense">{{$t('btn_search')}}</el-button>
        <p class="pointer cancel-Btn" @click="showLicensePlate=false" sty>{{$t('btn_cancel')}}</p>
    </div>
  </div>
</template>

<script>
import {isMobile} from "@/utils/index"
export default {
  name: "warranty",
  components: {},
  data() {
    return {
      stateSche: 0,
      mobileType:null,
      bgImg:require("../../assets/images/warranty_bg.png"),
      searchSelect:"1",
      showLicensePlate:false,
      installVal:"",
      licensePlateDoor: false,
      activeIndex: 0,
      licensePlateUnit: [],
      columns: [//省缩写选择
        '京', '沪', '鄂', '湘', '川', '渝', '粤', '闽', '晋', '黑',
        '津', '浙', '豫', '赣', '贵', '青', '琼', '宁', '吉', '蒙',
        '冀', '苏', '皖', '桂', '云', '陕', '甘', '藏', '新', '辽',
        '鲁'],
      numberColumns: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0','Q', 'W', 'E',
        'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Z',
        'X', 'C', 'V', 'B', 'N', 'M', '港','澳','学','领','警'
      ],

      el_select_lang:{
        phone:"",
        barcode:"",
        input_select:"",
      },

    };
  },

  created() {},
  mounted() {
    this.el_select_lang={
       phone:this.$t('phone'),
        barcode:this.$t('barcode'),
        input_select:this.$t('input_select'),
    }
    this.mobileType = isMobile()
  },

  methods: {
    //查询
    handleFilter() {
      if(!this.installVal){
        this.$message({
            type: "error",
            message:"请输入完整车牌号"
          });
        return
      }
      let searchSelect=this.searchSelect;
      if(searchSelect==1){
        this.showLicensePlate=true;
      }else{
        this.submitQuery({code:this.installVal})
      }
    },

    handleLicense(){
      if(this.licensePlateUnit.length<7){
        this.$message({
            type: "error",
            message:"请输入完整车牌号"
          });
        return
      }
      let license=this.licensePlateUnit.join('');
      this.submitQuery({phone:this.installVal,license:license})
    },

    submitQuery(params){
      this.showLicensePlate=false;
      this.$router.push({ path: "/warranty/detail",query: params});
    },


     pickOn(value) {
      this.licensePlateDoor = true;
      if (this.licensePlateUnit.length <= 7) {
        this.licensePlateUnit.push(value)
      }
    },
    delCarNo() {
      this.licensePlateUnit.pop();
    },
    confirm() {
      if(this.licensePlateUnit.length >= 7) {
        this.licensePlateDoor = false;
      }
    },
  },

  watch: {},
};
</script>

<style>
.page-warranty .el-input-group__append{
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
  padding: 0 30px;
}
.page-warranty .el-input-group__prepend{
  background-color: #fff;
}
.page-warranty .el-select .el-input {
    width: 90px;
  }
</style>

<style scoped lang="scss">
body{
  background-color: #333;
}
.pagecontent {
  padding: 50px 30px 20px;
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 5;
  width: 100%;
  height: 100%;
  transform: translateX(-50%);
  color: #fff;
  background-color: #333;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;

  .title{
   font-size: 42px;
   margin-bottom: 60px;
   letter-spacing: 3px;
  }

  .serach-input {
    width: 80%;
    max-width: 660px;
    margin: 0 auto 15%;
  }
}

.dialog-mask{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 8;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.licensePlate-dialog{
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 10;
  transform: translate(-50%,-50%);
  background-color: #fff;
  border-radius: 12px;
  padding: 20px 80px;

 .pop-title{
  margin-bottom: 10px;
 }
 .el-btn{
  width:200px;
  margin: 20px auto 20px;
 }

 .cancel-Btn{
  letter-spacing: 4px;
  font-size: 14px;
 }
}

// 输入车牌号
.carNoBox-mask{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
}
.carNoBoxSeat{
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 21;
}
 .carNo {
    border-radius: 6px;
    background: #fff;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    min-width:28px;
    margin: 6px;
    padding: 12px;
    cursor: pointer;
    box-sizing: content-box;
  }
  .inputBox {
    color: #333;
    height: 30px;
    line-height: 30px;
    width: 30px;
    font-size: 28px;
    text-align: center;
    background-color: transparent;
    border: none;
    outline: none;
    caret-color: rgba(0, 0, 0, 0);
    border-bottom:2px solid transparent;
  }
  .inputBox:focus {
    border-bottom-color: #888;
    transition: all 0.5s;
  }
  .dot {
    margin:0 4px 6px;
    background-color: #333;
    height: 6px;
    width: 6px;
    border-radius: 50%;
    display: inline-block
  }
  .delBt {
    background: #ACB3BB;
    border-radius: 6px;
    display: inline-block;
    font-weight: bold;
    font-size: 20px;
    margin: 6px;
    padding: 12px;
    cursor: pointer;
  }
  .carNoBoxInput {
    display: flex;
    align-items: center;
    border-radius: 8px;
    margin: 12px 0;
  }
  .carNoBoxInput .view{
   padding: 10px 15px;
   border: 2px solid #888;
   border-radius:50px;
   margin: 6px 3px 6px 6px;
  }

  .carNoBox {
    background: #D0D5D9;
    position: relative;
    width: 600px;
    border-radius: 6px;
    display: flex;
    flex-wrap: wrap;
    justify-items: center;
    align-items: center;
    z-index:20;
  }

  .newEnergyIcon{
    width: 24px;
    height: 24px;
    margin: 0 6px;
  }

@media (max-width: 550px) {
  .carNoBoxSeat{
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
  }
    .carNoBoxSeat .carNoBox{
      width: 100%;
    }
}


</style>